module.exports = __webpack_public_path__ + "static/media/planEmerg_5.ee985540.png";